import Config from '../../config/app';
import { mapGetters, mapActions } from 'vuex';

export default {
	computed: {
		...mapGetters({
			user: 'User/getUser',
			settings: 'Settings/get',
			getOrderItems: 'Basket/getOrder',
			isUserLoggedIn: 'User/isLoggedIn',
			getBasketItems: 'Basket/getItems',
			getPaymentModes: 'PaymentModes/getAll',
			getPaymentDetails: 'Basket/getPaymentDetails'
		}),	

		/**
		 * Should allow individual checkouts if the orders are more than one.
		 * 
		 * @return {Boolean}
		 */
		showIndividualCheckOut() {
			return Object.values(this.getBasketItems).length > 1 ? true: false;
		},

		/**
		 * Compute the total for each order going to a particular restaurant.
		 * 
		 * @return {Object}
		 */
		individualTotalPrices() {
			let individualTotals = {};
			let restuarants = this.isCheckOut ? this.getOrderItems : this.getBasketItems; 

			for (let restaurant of Object.values(restuarants)) {
				// Use restaurant id as key
				individualTotals[restaurant[0].menuItem.restaurant.id] = this.getOrderTotalPrice(restaurant);
			}

			return individualTotals;
		},

		/**
		 * Compute the total price for all the items in the basket.
		 * 
		 * @return {Number}
		 */
		totalPrice() {
			return Object.values(this.individualTotalPrices)
						.reduce((sum, value) => {
							return sum + value;
						}, 0);
		},

		/**
		 * Compute the total delivery fees for all the orders.
		 * 
		 * @return {Number}
		 */
		totalDeliveryFees() {
			let total = 0;
			let restuarants = this.isCheckOut ? this.getOrderItems : this.getBasketItems; 

			for (let restaurant of Object.values(restuarants)) {
				total += Number(restaurant[0].menuItem.restaurant.delivery_service.delivery_fee);
			}

			return total;
		},	

		/**
		 * Get the overall total price for the given orders.
		 * 
		 * @return {Number} 
		 */
		overallTotalPrice() {
			return this.totalPrice + this.totalDeliveryFees + this.getServiceFee(this.totalPrice);
		},

		/**
		 * Check if the current route is the checkout route.
		 * 	
		 * @return {Boolean}
		 */
		isCheckOut() {
			return this.$route.name.toLowerCase() === 'checkout';
		}
	},

	methods: {
		...mapActions({
			loadSettings: 'Settings/all',
		}),

		/**
		 * Get the delivery fee of a restaurant.
		 * Check if the delivery service charges per pack and 
		 * return the appropriate delivery fee.
		 * 
		 * @param {Array} restaurant
		 * @return {Number}
		 */
		getDeliveryFee(restaurant = null) {
			let deliveryFee = 0;
			let deliveryService;

			if (restaurant) {
				deliveryService = restaurant[0].menuItem.restaurant.delivery_service;

				if (deliveryService.fee_on_packs) {
					for (let menuItem of restaurant) {
						deliveryFee += Number(deliveryService.delivery_fee) * Number(menuItem.details.quantity);
					}
				} else {
					deliveryFee = Number(deliveryService.delivery_fee);
				}
			}

			return deliveryFee;
		},

		/**
		 * Get our service charge for the order.	
		 * 
		 * @param  {Number} order_value
		 * @return {Number}             
		 */	
		getServiceFee(order_value = 0) {
			if (!this.isUserLoggedIn) {
				return 0; 
			}

			if (this.getPaymentDetails && this.isCash(this.getPaymentDetails.payment_mode_id)) {
				return Number(order_value) <= Number(this.settings.pivot) ? Number(this.settings.cash_below) : Number(this.settings.cash_above);
			}

			return Number(order_value) * Number(this.settings.online_charge);
		},

		/**
		 * Return the sum of the arguments provided.
		 * 
		 * @param  {Array} values
		 * @return {Number}          
		 */
		getTotal(...values) {
			return values.reduce((sum, value) => {
				return sum + Number(value);
			}, 0);
		},

		/**
		 * Compute the total price for a specific order.			
		 * 
		 * @param  {Object} order
		 * @return {Number}      
		 */
		getOrderTotalPrice(order) {
			let totalPrice = 0;

			for (let item of order) {
				let itemQuantity = Number(item.details.price);
				let itemPrice = Number(item.details.quantity);
				
				if (!isNaN(itemQuantity) && !isNaN(itemPrice)) {
					totalPrice += itemQuantity * itemPrice;
				}
			}

			return totalPrice;
		},

		/**
		 * Toggle the drop down and drop up icons,
		 * when a panel header is clicked.
		 * 
		 * @param  {Object} event
		 * @return {Undefined}      
		 */
		toggleNavigation(event) {
			$(event.target).parent()
							.find('i')
							.toggleClass('hidden');
		},

		/**
		 * Check if the specified payment mode is cash.
		 * 
		 * @param  {Number}  payment_mode_id
		 * @return {Boolean}                
		 */
		isCash(payment_mode_id) {
			let status = false;

			for (let paymentMode of this.getPaymentModes) {
				if (payment_mode_id === paymentMode.id && paymentMode.name.toLowerCase() === 'cash') {
					status = true;
					break;
				}
			}

			return status;
		}
	},

	created() {
		this.showLoader();

		this.loadSettings()
			.catch(error => {
				this.buildErrorMessages(error)
					.then(data => {
						this.notify({
							message: data,
							type: 'danger',
						});
					});
			})
			.then(() => this.hideLoader());
	}
}


// WEBPACK FOOTER //
// ./src/mixins/order.js